import { fetchClaimEnquiry } from "../../api/claim-enquiry";
import { useQuery } from "@tanstack/react-query";

export function useFetchClaimEnquiry({ uuid, enabled }: { uuid: string; enabled?: boolean }) {
  const { data, isError, isLoading } = useQuery({
    queryKey: ["claimEnquiry", uuid],
    queryFn: () => fetchClaimEnquiry(uuid),
    retry: false,
    enabled: enabled,
  });
  return { claimEnquiry: data, isError, isLoading };
}
